import { render, staticRenderFns } from "./VideoCallDKTT.vue?vue&type=template&id=156641a2&scoped=true"
import script from "./VideoCallDKTT.vue?vue&type=script&lang=js"
export * from "./VideoCallDKTT.vue?vue&type=script&lang=js"
import style0 from "./VideoCallDKTT.vue?vue&type=style&index=0&id=156641a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156641a2",
  null
  
)

export default component.exports